// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3O7Lf","list":"PatternAutocomplete_list__3Cwwb"};